const headers = [
  {
    text: 'Học sinh',
    value: 'student',
  },
  {
    text: 'Ngày sinh',
    value: 'dob',
  },
  // {
  //   text: 'Trạng thái',
  //   value: 'status',
  // },
  // {
  //   text: 'Lý do',
  //   value: 'notes',
  // },
  {
    text: 'Thao tác',
    value: 'actions',
    align: 'end',
  },
  {
    text: '',
    value: 'actionDetail',
    align: 'end',
  },
]

function getStatusData(type, status) {
  switch (status) {
    case 'present':
      if (type === 'color') return 'color: green'
      return 'Có mặt'
    case 'absent':
      if (type === 'color') return 'color: orange'
      return 'Vắng mặt'
    default:
      return 'Chưa điểm danh'
  }
}
function getDataSubStatus(type, status) {
  switch (status) {
    case 'onTime':
      if (type === 'color') return 'color: green'
      return 'Đúng giờ'
    case 'lateTime':
      if (type === 'color') return 'color: orange'
      return 'Vào muộn'
    case 'excused':
      if (type === 'color') return 'color: green'
      return 'Có phép'
    case 'unexcused':
      if (type === 'color') return 'color: orange'
      return 'Không phép'
    default:
      return ''
  }
}
export { headers, getStatusData, getDataSubStatus }
